import {
  type CreateAxiosDefaults,
  InternalAxiosRequestConfig,
  type RawAxiosRequestHeaders,
} from 'axios';
import { isServer } from '@frodo/lib/utils/common/helper';
import { LUMBERJACKID_KEY } from '@frodo/lib/services/http/shared/constants';
import { getLumberjackId } from '@frodo/lib/services/http/shared/lumberjack';
import ApiHttpBaseService from './api-http-base.service';

// client modules are also evaluated during SSR, where there is no window
const getBrowserOrigin = (): string | undefined =>
  isServer ? undefined : window.location.origin;

class ApiHttpClientService extends ApiHttpBaseService {
  constructor(
    baseUrl: string | undefined = getBrowserOrigin(),
    requestHeaders: RawAxiosRequestHeaders = {},
    axiosConfig: CreateAxiosDefaults = {},
  ) {
    super(
      baseUrl,
      requestHeaders,
      { withCredentials: true, ...axiosConfig, adapter: 'fetch' },
    );

    this.setupInterceptors();
  }

  protected setupInterceptors(): void {
    this.apiClient.interceptors.request.use(this.attachLumberjackId);
  }

  private attachLumberjackId = (
    config: InternalAxiosRequestConfig,
  ): InternalAxiosRequestConfig => {
    const existingLumberjackId = config.headers.get(LUMBERJACKID_KEY);

    config.headers.set(
      LUMBERJACKID_KEY,
      getLumberjackId(
        typeof existingLumberjackId === 'string' ? existingLumberjackId : '',
      ),
    );

    return config;
  };
}

export default ApiHttpClientService;
